module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-02@2x.fb7e6df7.jpg";